import { MemorySearchSettings } from '../memory-search-client/memory-search-client';

export interface RecentSearchesSourceSettings extends MemorySearchSettings {
  type: 'recent-search';
  flag?: 'enableLauncherRecentSearch';
}
